/* ==========================================================================
   PROTÉGEZ VOS PROCHES — moteur d'animations
   Vanilla JS : IntersectionObserver + requestAnimationFrame + position:sticky
   Aucune dépendance. transform/opacity uniquement. Reduced-motion respecté.
   ========================================================================== */
(function () {
  "use strict";

  var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var finePointer = window.matchMedia("(pointer: fine)").matches;
  var vh = window.innerHeight;

  /* ---------------- header : transparent -> glass ---------------- */
  var header = document.querySelector(".hd");
  function headerState() {
    if (header) header.classList.toggle("scrolled", window.scrollY > 40);
  }

  /* burger mobile */
  var burger = document.querySelector(".hd__burger");
  if (burger && header) {
    burger.addEventListener("click", function () {
      var open = header.classList.toggle("open");
      burger.setAttribute("aria-expanded", open ? "true" : "false");
    });
    header.querySelectorAll(".hd__nav a").forEach(function (a) {
      a.addEventListener("click", function () {
        header.classList.remove("open");
        burger.setAttribute("aria-expanded", "false");
      });
    });
  }

  /* ---------------- barre de progression ---------------- */
  var progress = document.querySelector(".progress i");
  function progressState() {
    if (!progress) return;
    var max = document.documentElement.scrollHeight - window.innerHeight;
    progress.style.transform = "scaleX(" + (max > 0 ? window.scrollY / max : 0) + ")";
  }

  /* ---------------- reveals ---------------- */
  /* découpe mot à mot pour .words */
  document.querySelectorAll(".words").forEach(function (el) {
    var lines = el.innerHTML.split(/<br\s*\/?>/i);
    el.innerHTML = lines
      .map(function (line) {
        return line
          .trim()
          .split(/\s+/)
          .filter(Boolean)
          .map(function (w, i) {
            return '<span class="w" style="transition-delay:' + (i * 70) + 'ms">' + w + "</span>";
          })
          .join(" ");
      })
      .join("<br>");
  });

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add("in");
          io.unobserve(e.target);
        }
      });
    },
    { rootMargin: "0px 0px -12% 0px", threshold: 0.05 }
  );
  document.querySelectorAll("[data-reveal],.words").forEach(function (el) { io.observe(el); });

  /* ---------------- sticky CTA mobile : après le hero ---------------- */
  var stickyCta = document.querySelector(".sticky-cta");
  var hero = document.querySelector(".hero");
  if (stickyCta && hero) {
    new IntersectionObserver(function (entries) {
      stickyCta.classList.toggle("show", !entries[0].isIntersecting);
    }, { threshold: 0.05 }).observe(hero);
  }

  /* ---------------- parallax (rAF + lerp) ---------------- */
  var pItems = [];
  document.querySelectorAll("[data-parallax]").forEach(function (el) {
    pItems.push({ el: el, speed: parseFloat(el.getAttribute("data-parallax")) || 0.2, cur: 0 });
  });

  /* ---------------- scènes sticky ---------------- */
  var scenes = [];
  document.querySelectorAll(".scene").forEach(function (scene) {
    scenes.push({ el: scene, pin: scene.querySelector(".scene__pin") });
  });

  function sceneProgress(scene) {
    var r = scene.el.getBoundingClientRect();
    var total = r.height - vh;
    if (total <= 0) return 0;
    return Math.min(1, Math.max(0, -r.top / total));
  }

  /* scène appel */
  var call = document.querySelector(".call");
  /* scène svp */
  var svp = document.querySelector(".svp");
  var svpPanels = svp ? svp.querySelectorAll(".svp__panel") : [];
  var svpDots = svp ? svp.querySelectorAll(".svp__dots i") : [];
  /* scène voix */
  var voice = document.querySelector(".voice");
  var waveBars = voice ? voice.querySelectorAll(".wave i") : [];
  var waveHeights = [];
  waveBars.forEach(function () { waveHeights.push(12 + Math.random() * 80); });
  var waveTick = 0;

  function updateScenes() {
    scenes.forEach(function (s) {
      var p = sceneProgress(s);

      if (call && s.el.contains(call)) {
        call.querySelector(".call__b1").classList.toggle("show", p > 0.22);
        call.querySelector(".call__b2").classList.toggle("show", p > 0.45);
        call.classList.toggle("s3", p > 0.7);
      }

      if (svp && s.el.contains(svp)) {
        var idx = p < 0.18 ? 0 : p < 0.45 ? 1 : p < 0.72 ? 2 : 3;
        svpPanels.forEach(function (panel, i) { panel.classList.toggle("on", i === idx); });
        svpDots.forEach(function (d, i) { d.classList.toggle("on", i === idx); });
      }

      if (voice && s.el.contains(voice)) {
        voice.classList.toggle("synthetic", p > 0.42);
        voice.classList.toggle("reveal", p > 0.6);
        if (!reduced && p > 0.02 && p < 0.98) {
          waveTick++;
          if (waveTick % 4 === 0) {
            waveBars.forEach(function (b, i) {
              var synthetic = p > 0.42;
              var h = synthetic
                ? 18 + ((i * 37) % 5) * 14           /* motif régulier "numérique" */
                : 10 + Math.abs(Math.sin(i * 0.9 + waveTick * 0.12)) * waveHeights[i];
              b.style.height = h + "%";
            });
          }
        }
      }
    });
  }

  /* ---------------- boucle rAF ---------------- */
  var ticking = false;
  function frame() {
    ticking = false;
    headerState();
    progressState();
    if (reduced) return;

    var sy = window.scrollY;
    pItems.forEach(function (it) {
      var r = it.el.getBoundingClientRect();
      var center = r.top + r.height / 2 - vh / 2;
      var target = -center * it.speed;
      it.cur += (target - it.cur) * 0.12; /* lerp = fluidité */
      it.el.style.transform = "translate3d(0," + it.cur.toFixed(1) + "px,0)" +
        (it.el.hasAttribute("data-parallax-scale") ? " scale(1.15)" : "");
    });
    updateScenes();
  }
  function onScroll() {
    if (!ticking) { ticking = true; requestAnimationFrame(frame); }
  }
  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", function () { vh = window.innerHeight; onScroll(); }, { passive: true });
  frame();
  if (reduced) { updateScenesReduced(); }
  function updateScenesReduced() {
    /* en reduced-motion : tout est visible, états finaux */
    document.querySelectorAll(".call__bubble").forEach(function (b) { b.classList.add("show"); });
    if (call) call.classList.add("s3");
    svpPanels.forEach(function (p) { p.classList.add("on"); });
    if (voice) { voice.classList.add("reveal"); }
  }

  /* ---------------- tilt 3D du mockup (desktop) ---------------- */
  var mock = document.querySelector(".mock__book");
  if (mock && finePointer && !reduced) {
    var mockWrap = mock.closest(".mock");
    var rx = 4, ry = -14, trx = 4, tryy = -14;
    mockWrap.addEventListener("mousemove", function (e) {
      var r = mockWrap.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - 0.5;
      var y = (e.clientY - r.top) / r.height - 0.5;
      tryy = -14 + x * 14;
      trx = 4 - y * 10;
    });
    mockWrap.addEventListener("mouseleave", function () { trx = 4; tryy = -14; });
    (function tiltLoop() {
      rx += (trx - rx) * 0.08;
      ry += (tryy - ry) * 0.08;
      mock.style.transform = "rotateY(" + ry.toFixed(2) + "deg) rotateX(" + rx.toFixed(2) + "deg)";
      requestAnimationFrame(tiltLoop);
    })();
  }

  /* ---------------- lumière des cartes ---------------- */
  if (finePointer) {
    document.querySelectorAll(".card").forEach(function (card) {
      card.addEventListener("mousemove", function (e) {
        var r = card.getBoundingClientRect();
        card.style.setProperty("--mx", ((e.clientX - r.left) / r.width * 100) + "%");
      });
    });
  }

  /* ---------------- boutons légèrement magnétiques (desktop) ---------------- */
  if (finePointer && !reduced) {
    document.querySelectorAll(".btn").forEach(function (btn) {
      btn.addEventListener("mousemove", function (e) {
        var r = btn.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        btn.style.transform = "translate(" + (x * 8) + "px," + (y * 6 - 2) + "px)";
      });
      btn.addEventListener("mouseleave", function () { btn.style.transform = ""; });
    });
  }

  /* ---------------- carousel aperçus ---------------- */
  document.querySelectorAll(".gal").forEach(function (gal) {
    var track = gal.querySelector(".gal__track");
    var prev = gal.querySelector("[data-prev]");
    var next = gal.querySelector("[data-next]");
    function step() {
      var item = track.querySelector(".gal__item");
      return item ? item.getBoundingClientRect().width + 20 : 300;
    }
    if (prev) prev.addEventListener("click", function () { track.scrollBy({ left: -step(), behavior: "smooth" }); });
    if (next) next.addEventListener("click", function () { track.scrollBy({ left: step(), behavior: "smooth" }); });
  });

  /* ---------------- achat : mode checkout direct ---------------- */
  document.querySelectorAll("form[data-buy-mode='checkout']").forEach(function (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var fd = new FormData(form);
      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : "/") + "cart/add.js", {
        method: "POST", body: fd
      }).then(function () { window.location.href = "/checkout"; })
        .catch(function () { form.submit(); });
    });
  });

  /* ---------------- ancres douces avec offset header ---------------- */
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener("click", function (e) {
      var id = a.getAttribute("href");
      if (id.length < 2) return;
      var t = document.querySelector(id);
      if (!t) return;
      e.preventDefault();
      var y = t.getBoundingClientRect().top + window.scrollY - 70;
      window.scrollTo({ top: y, behavior: reduced ? "auto" : "smooth" });
    });
  });
})();
